import { useEffect, useLayoutEffect, useState } from "react";

// router
import { useNavigate, useParams } from "react-router-dom";

// bootstrap
import { Button, Container } from "react-bootstrap";

// componentes
import Migas from "../migasGeomedellin/Migas";
import PiePagina from "../piePagina/PiePagina";
import Rating from "../../common/Rating";
import Load from "../../common/Load";

// http services request
import getDatos from "../../../services/grupos/getDatos";
import guardarUbicacion from "../../../services/guardarUbicacion";

// Variables globales
import { URL_IMAGE_GEOMEDELLIN } from "../../../environment";

export default function InfoGrupos({
  idComponente,
  caracFiltro,
  imagen,
  descripcion,
}) {
  const { id } = useParams();
  const navigate = useNavigate();

  // data openData
  const [grupoInfo, setGrupoInfo] = useState([]);

  // Load
  const [load, setLoad] = useState(false);

  useEffect(() => {}, []);

  const obtenerDatosGrupos = async () => {
    setLoad(true);
    try {
      const response = await getDatos(`geomed/grupos/consultaSA/${id}`);
      setGrupoInfo(response);
    } catch (err) {
      alert("Error");
      navigate("/grupos");
    } finally {
      setLoad(false);
    }
  };

  useLayoutEffect(() => {
    obtenerDatosGrupos();
    window.scroll(0, 0);
  }, [id]);

  return (
    <>
      <Container fluid={true} className="content-datosabiertos">
        <div
          className="img-logo-datosabiertos"
          style={{
            backgroundImage: `url("${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/Banner/${idComponente}/${imagen}")`,
          }}
        >
          <div className="content-degradado">
            <div className="content-contendido-img-banner">
              <label className="lblitulo-txt-imgbanner">
                {grupoInfo?.nombre_grupo}
              </label>
              <p>
                <label className="lbdescripcion-txt-imgbanner">
                  {descripcion}
                </label>
              </p>
            </div>
          </div>
          <label className="color-borde-img-banner"></label>
        </div>
        <Migas ruta="Grupos" />
        <Container>
          <div
            className="grid-container-info-noticias"
            key={grupoInfo?.id_grupo}
          >
            <div className="info-noticias-seccion">
              <p className="titulo-noticia">{grupoInfo?.nombre_grupo}</p>
              <span>{grupoInfo?.descripcion}</span>
            </div>
            <hr className="hr-propiedades" />
            <div className="info-container-admin-equipo-vigencia">
              <div className="info-admin">
                <div className="info-admin-admin">
                  <label>Administrador</label>
                  {grupoInfo?.admin_lista?.map((item) => {
                    return (
                      <ul>
                        <li>{item.nombres}</li>
                        <li>Documento: {item.identificador}</li>
                        <li>Correo: {item.email}</li>
                      </ul>
                    );
                  })}
                </div>
                <div className="info-admin-vigencia">
                  <label>Vigencia acceso administrador</label>
                  <ul>
                    <li>
                      {grupoInfo.vigencia_admon === 365
                        ? "1 Año"
                        : grupoInfo.vigencia_admon === 180
                        ? "6 Meses"
                        : "3 Meses"}
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div className="info-admin">
                <div className="info-admin-admin">
                  <label>Miembros del equipo</label>
                  {grupoInfo?.equipo_lista?.map((item) => {
                    return (
                      <ul>
                        <li>{item.nombres}</li>
                        <li>Documento: {item.identificador}</li>
                        <li>Correo: {item.email}</li>
                      </ul>
                    );
                  })}
                </div>
                <div className="info-admin-vigencia">
                  <label>Vigencia acceso equipo</label>
                  <ul>
                    <li>
                      {grupoInfo.vigencia_equipo === 365
                        ? "1 Año"
                        : grupoInfo.vigencia_equipo === 180
                        ? "6 Meses"
                        : "3 Meses"}
                    </li>
                  </ul>
                </div>
              </div>
              <hr />
              <div>
                <label>Subgrupos</label>
                {grupoInfo?.sub_grupo_lista?.map((item) => {
                  return (
                    <ul>
                      <li>{item.nombre}</li>
                    </ul>
                  );
                })}
              </div>
            </div>
          </div>
        </Container>
        <Load visible={load} />
      </Container>
      <PiePagina fluid={true} />
    </>
  );
}
